import * as React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { AppState } from '../store'
import { CurrentState } from '../current/types'
import Client from '../client'
import { Organization } from '../types/api'
import { readQueryParams } from '../utils/pagination'
import { showSuccess } from '../Toast'
import { UprightStyle } from '../types'
import { CopySnippet } from './CopySnippet'

const style: UprightStyle = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  select: {
    width: 450,
    textAlign: 'left'
  }
}

interface EmployeeSwitcherProps {
  current: CurrentState
}

interface EmployeeSwitcherState {
  organizations: Organization[]
  organizationId: number
}

class EmployeeSwitcher extends React.Component<EmployeeSwitcherProps, EmployeeSwitcherState> {
  constructor(props) {
    super(props)
    this.state = {
      organizations: [],
      organizationId: props.current.organization.id
    }
  }

  componentDidMount() {
    this.fetchData()
    if (readQueryParams().switched_to) {
      showSuccess(`Switched to ${this.props.current.organization.name}`)
      window.history.replaceState({}, document.title, document.location.pathname)
    }
  }

  fetchData = async () => {
    try {
      const res = await Client.getOrganizations()
      this.setState({ organizations: res.data.organizations })
    } catch (e) {
      // If we get an error, the best we can do is recover gracefully with what we have from the orgconfing
      const currentOrganization = this.props.current.organization
      this.setState({
        organizations: [{ id: currentOrganization.id, name: currentOrganization.name, zipcode: null, timezone: null }]
      })
    }
  }

  onOrganizationChange = (id: number) => {
    this.setState({ organizationId: id })
    window.location.href = `/sessions/employee_switch/${id}`
  }

  render() {
    const { organizationId, organizations } = this.state
    const selectedOrganization = organizations.find(org => org.id === organizationId)

    // Construct the text to copy
    const textToCopy = selectedOrganization ? `${selectedOrganization.name} (${selectedOrganization.id})` : ''

    return (
      <div style={style.container} data-testid="employee-switcher">
        <div style={style.select}>
          <Select
            value={this.state.organizationId}
            onChange={this.onOrganizationChange}
            options={this.state.organizations.map(s => ({ label: `${s.name} (${s.id})`, value: s.id }))}
            simpleValue
            clearable={false}
          />
        </div>
        {selectedOrganization && (
          <CopySnippet
            value={textToCopy}
            toastValue={`${selectedOrganization.name} (${selectedOrganization.id})`}
            className="override-black"
            hideText
            color="gray"
            iconSize={12}
          />
        )}
      </div>
    )
  }
}

export default connect((state: AppState) => ({ current: state.current }))(EmployeeSwitcher)
